<template>
  <div class="card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-2">
          <div class="input-block mb-3 form-focus focused">
            <div class="cal-icon">
              <datepicker
                v-model="startDate"
                placeholder="Choose Date"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
                @update:model-value="fetchPayPeriodData"
              />
              <label class="focus-label">Start Date</label>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-2">
          <div class="input-block mb-3 form-focus focused">
            <div class="cal-icon">
              <datepicker
                v-model="endDate"
                placeholder="Choose Date"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
                @update:model-value="fetchPayPeriodData"
              />
              <label class="focus-label">End Date</label>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-2 mb-3">
          <a href="javascript:;" @click="toggleExpandAll">
            <span v-if="isAllExpanded"
              ><i class="fa-solid fa-angles-up"></i
            ></span>
            <span v-else><i class="fa-solid fa-angles-down"></i></span>
            {{ isAllExpanded ? "Collapse all" : "Expand all" }}
          </a>
        </div>

        <!-- Action Buttons Right Side -->
        <div class="col-sm-6 col-md-6 mb-3 text-end">
          <div class="btn-group">
            <a
              type="button"
              class="dropdown-toggle dropdown-toggle-split"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              More actions
            </a>
            <ul class="dropdown-menu">
              <li class="dropdown-submenu">
                <a
                  class="dropdown-item"
                  href="javascript:;"
                  v-if="hasExportPermission"
                >
                  <i class="fa-solid fa-print me-2"></i> Print Timesheet
                  <i class="fa-solid fa-angle-right float-end mt-1"></i>
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      @click="downloadPayPeriodPDF('default')"
                    >
                      <i class="fa-solid fa-table me-2"></i>Print By Default
                      View
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      @click="downloadPayPeriodPDF('employee')"
                    >
                      <i class="fa-solid fa-user me-2"></i>Print By Employee
                      View
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/global-settings" class="dropdown-item">
                  <i class="fa-solid fa-gear me-2"></i> Settings
                </router-link>
              </li>
            </ul>
          </div>
          <a
            class="list-view btn btn-link btn-primary mr-3"
            data-bs-toggle="modal"
            data-bs-target="#pay_period_manage_colvis"
            style="margin-right: 5px"
            title="colvis"
            ><i class="fa-solid fa-bars"></i
          ></a>
          <a
            v-if="hasCreatePermission"
            href="javascript:void(0);"
            class="btn btn-primary me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_timesheet"
            ref="addtimesheetref"
            @click="openAddTimeCard"
            ><i class="fa-solid fa-plus"></i> Add time card</a
          >
          <button
            v-if="hasExportPermission"
            class="btn btn-primary"
            @click="downloadPayPeriod('export-pay-period')"
          >
            <i class="fa-solid fa-download"></i> Download
          </button>
        </div>
      </div>
      <div class="row mb-3" v-if="hasEditPermission">
        <a
          href="javascript:void(0);"
          style="color: #1f1f1f"
          @click="toggleFilters"
        >
          <span v-if="showFilters">
            <i class="fa-solid fa-chevron-up me-1"></i>
          </span>
          <span v-else>
            <i class="fa-solid fa-chevron-down me-1"></i>
          </span>
          Manage timesheet view
        </a>

        <!-- Filter -->
        <div class="filter-section" :class="{ 'show-filters': showFilters }">
          <Form @submit.prevent="onSearch">
            <div class="row filter-row align-items-center">
              <div class="col-sm-6 col-md-3">
                <div class="input-block mb-2 form-focus focused">
                  <vue-select
                    :options="employee_list"
                    v-model="searchForm.s_employee_id"
                    id="employeeList"
                    placeholder="-"
                    @update:modelValue="onSearch"
                  />
                  <label class="focus-label">Employee Name</label>
                </div>
              </div>

              <div class="col-sm-6 col-md-3">
                <div class="input-block mb-2 form-focus focused">
                  <vue-select
                    :options="designation_list"
                    v-model="searchForm.designation_id"
                    placeholder="-"
                    id="designationList"
                    @update:modelValue="onSearch"
                  />
                  <label class="focus-label">Select Position</label>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="form-check form-switch mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="hideEmptyMembers"
                    v-model="searchForm.hide_empty_members"
                    @change="onSearch"
                  />
                  <label
                    class="form-check-label mt-2 ms-2"
                    for="hideEmptyMembers"
                  >
                    Hide team members without hours
                  </label>
                </div>
              </div>

              <!-- <div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <button class="btn btn-success w-100 mb-3 submit-btn">
                  Search
                </button>
              </div>
            </div> -->

              <div class="col-sm-6 col-md-2">
                <div class="d-grid">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-danger w-100 submit-btn"
                    @click="clearForm"
                    >Clear</a
                  >
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <!-- Need Review Toggle -->
      <div class="row" :class="{ 'mb-3': !showNeedReview }">
        <a
          href="javascript:void(0);"
          style="color: #1f1f1f"
          @click="toggleNeedReview"
        >
          <span v-if="showNeedReview">
            <i class="fa-solid fa-chevron-up me-1"></i>
          </span>
          <span v-else>
            <i class="fa-solid fa-chevron-down me-1"></i>
          </span>
          Need review
          <span class="no-show-count">{{ noShowCards.length }}</span>
        </a>
      </div>

      <!-- No-Show Cards Section -->
      <div v-if="showNeedReview" class="no-show-container mb-3">
        <template v-if="hasEditPermission">
          <div class="no-show-cards">
            <div
              v-for="(card, index) in noShowCards"
              :key="'no-show-' + index"
              class="no-show-card"
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#edit_timesheet"
              @click="openModal(card)"
            >
              <div class="card-content">
                <div class="employee-info">
                  <a-avatar class="me-2" style="background-color: #f8f9fa">
                    <img
                      v-if="card.parent.avatar"
                      :src="getEmployeeAvatar(card.parent.avatar)"
                      alt="User Image"
                      @error="handleImageError(card.parent)"
                    />
                    <img
                      v-else
                      :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                      alt="User Image"
                    />
                  </a-avatar>
                  <div class="employee-details">
                    <div class="employee-name">
                      {{ card.parent.employee_name }}
                    </div>
                    <div class="attendance-date">{{ card.date }}</div>
                    <div class="no-show-status">
                      <exclamation-icon
                        style="color: #ff4d4f; font-size: 14px"
                        class="exclamation-icon me-1"
                      />
                      <span class="no-show-text">{{ card.time_card }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-overlay"></div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-show-cards">
            <div
              v-for="(card, index) in noShowCards"
              :key="'no-show-' + index"
              class="no-show-card"
              style="cursor: default"
            >
              <div class="card-content">
                <div class="employee-info">
                  <a-avatar class="me-2" style="background-color: #f8f9fa">
                    <img
                      v-if="card.parent.avatar"
                      :src="getEmployeeAvatar(card.parent.avatar)"
                      alt="User Image"
                      @error="handleImageError(card.parent)"
                    />
                    <img
                      v-else
                      :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                      alt="User Image"
                    />
                  </a-avatar>
                  <div class="employee-details">
                    <div class="employee-name">
                      {{ card.parent.employee_name }}
                    </div>
                    <div class="attendance-date">{{ card.date }}</div>
                    <div class="no-show-status">
                      <exclamation-icon
                        style="color: #ff4d4f; font-size: 14px"
                        class="exclamation-icon me-1"
                      />
                      <span class="no-show-text">{{ card.time_card }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-overlay"></div>
            </div>
          </div>
        </template>
      </div>
      <div class="showentries mb-3">
        <label
          >Show
          <select v-model="pagination.pageSize" @change="updatePerPage">
            <option value="11">10</option>
            <option value="26">25</option>
            <option value="51">50</option>
            <option value="101">100</option>
          </select>
          entries</label
        >
      </div>
      <div style="overflow-x: auto">
        <a-table
          class="stripped table-hover"
          :columns="originalColumn"
          :data-source="dataWithKeysAndTotals"
          :pagination="pagination"
          :expandIconColumnIndex="0"
          :expandedRowKeys="expandedRowKeys"
          @expand="handleExpand"
          @rowClick="handleRowClick"
          :customRow="customRow"
          :loading="loading"
          @change="handleTableChange"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'date' && record.children">
              <a-avatar class="me-2" style="background-color: #ccc">
                <img
                  v-if="record.avatar"
                  :src="getEmployeeAvatar(record?.avatar)"
                  alt="User Image"
                  @error="handleImageError(record)"
                />
                <img
                  v-else
                  :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                  alt="User Image"
                />
              </a-avatar>
              <strong>{{ record.employee_name }}</strong>
            </template>

            <template
              v-if="
                column.key === 'date' && !record.children && !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.date }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'role' && !record.children && !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.role }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'wage_rate' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.wage_rate }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'time_card' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                <span
                  :class="{ 'text-danger': record.time_card === 'No-Show' }"
                >
                  {{ record.time_card }}
                </span>
              </a>
            </template>

            <template v-if="column.key === 'issues'">
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                <exclamation-icon
                  v-if="record.issues"
                  style="color: #ff4d4f; font-size: 16px"
                  class="exclamation-icon"
                />
              </a>
            </template>

            <template
              v-if="
                column.key === 'scheduled_hours' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.scheduled_hours }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'actual_vs_scheduled' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.actual_vs_scheduled }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'total_paid_hours' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.total_paid_hours }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'regular_hours' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.regular_hours }}
              </a>
            </template>
            <template
              v-if="
                column.key === 'unpaid_breaks' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.unpaid_breaks }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'ot_hours' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.ot_hours }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'estimated_wages' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.estimated_wages }}
              </a>
            </template>

            <template
              v-if="
                column.key === 'cash_tips' &&
                !record.children &&
                !record.isTotalRow
              "
            >
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#edit_timesheet"
                style="font-weight: 500"
                @click="openModal(record)"
              >
                {{ record.cash_tips }}
              </a>
            </template>

            <!-- Add Time Card Row -->
            <template v-else-if="record.isAddTimeCardRow">
              <template v-if="column.key === 'date'">
                <a
                  href="javascript:void(0);"
                  style="color: #0d6efd"
                  data-bs-toggle="modal"
                  data-bs-target="#add_timesheet"
                  ref="addtimesheetref"
                  @click="openAddTimeCard(record)"
                >
                  <i class="fa-solid fa-plus me-1"></i> Add Time Card
                </a>
              </template>
            </template>
          </template>
        </a-table>
      </div>
      <a
        v-if="hasEMpCreatePermission"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#add_employee"
        ><i class="fa-solid fa-plus"></i> Add New Team Member</a
      >
    </div>
    <time-card-model
      :UserId="selectedUserId"
      :DesignationId="selectedDesignationId"
      :selectedtimesheet="selectedtimesheet"
      :form="form"
      :formErrors="formErrors"
      @reload-data="reloadPayData"
    />
    <employee-model @reloadEmp="reloadPayData" />

    <!-- pay_period_manage_colvis Modal -->
    <div
      id="pay_period_manage_colvis"
      class="modal custom-modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Manage Column Visibility</h5>
            <!-- <small>select the column from the default that you want to hide</small> -->
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="modal_team_information_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-6"
                v-for="(column, key) in columns"
                :key="column.key"
              >
                <div class="input-block mb-3 d-flex">
                  <div class="form-switch" style="margin-right: 5px">
                    <input
                      v-model="column.visibility"
                      type="checkbox"
                      class="form-check-input"
                      :id="'customSwitch_' + column.key"
                      value="false"
                      :checked="column.visibility"
                    />
                  </div>
                  <label class="col-form-label"> {{ column?.title }} </label>
                </div>
              </div>
            </div>
            <!-- <div class="submit-section">
             <button class="btn btn-primary submit-btn" @click="" :disabled="disableButton">Submit</button>
           </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- pay_period_manage_colvis Modal -->
  </div>
</template>

<script>
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { notification } from "ant-design-vue";
import axios from "axios";
import moment from "moment";
import { Form } from "vee-validate";
import { ref } from "vue";

var pagination = {
  total: 0,
  current: 1,
  pageSize: 11,
  // showSizeChanger: true,
  showTotal: (total, range) => `Total ${total} records`, // `${range[0]}-${range[1]} of ${total} items`
};

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 120,
    visibility: true,
  },
  {
    title: "Position",
    dataIndex: "role",
    key: "role",
    width: 120,
    visibility: true,
  },
  {
    title: "Wage rate",
    dataIndex: "wage_rate",
    key: "wage_rate",
    width: 100,
    visibility: true,
  },
  {
    title: "Time card",
    dataIndex: "time_card",
    key: "time_card",
    width: 120,
    visibility: true,
  },
  {
    title: "Issues",
    dataIndex: "issues",
    key: "issues",
    width: 80,
    visibility: true,
  },
  {
    title: "Scheduled hours",
    dataIndex: "scheduled_hours",
    key: "scheduled_hours",
    width: 120,
    visibility: true,
  },
  {
    title: "Actual vs. scheduled",
    dataIndex: "actual_vs_scheduled",
    key: "actual_vs_scheduled",
    width: 150,
    visibility: true,
  },
  {
    title: "Total paid hours",
    dataIndex: "total_paid_hours",
    key: "total_paid_hours",
    width: 120,
    visibility: true,
  },
  {
    title: "Regular hours",
    dataIndex: "regular_hours",
    key: "regular_hours",
    width: 120,
    visibility: true,
  },
  {
    title: "Unpaid breaks",
    dataIndex: "unpaid_breaks",
    key: "unpaid_breaks",
    width: 120,
    visibility: true,
  },
  {
    title: "OT hours",
    dataIndex: "ot_hours",
    key: "ot_hours",
    width: 100,
    visibility: true,
  },
  {
    title: "Estimated wages",
    dataIndex: "estimated_wages",
    key: "estimated_wages",
    width: 120,
    visibility: true,
  },
  {
    title: "Cash tips",
    dataIndex: "cash_tips",
    key: "cash_tips",
    width: 120,
    visibility: true,
  },
];

export default {
  name: "PayPeriodReview",
  components: {
    "exclamation-icon": ExclamationCircleOutlined,
    Form,
  },
  data() {
    const currentDate = new Date();
    const lastWeekDate = new Date();
    lastWeekDate.setDate(currentDate.getDate() - 7);

    return {
      columns: columns,
      expandedRowKeys: [],
      isAllExpanded: false,
      defaultAvatar: "avatar-01.jpg",
      data: [],
      totalsRow: null,
      loading: false,
      startDate: lastWeekDate,
      endDate: currentDate,
      dateFormat: "MM-dd-yyyy",
      showFilters: false,
      showNeedReview: false,
      noShowCards: [],
      searchForm: {
        s_employee_id: null,
        designation_id: null,
        hide_empty_members: false,
      },
      employee_list: [],
      designation_list: [],
      selectedUserId: "",
      selectedDesignationId: "",
      selectedtimesheet: [],
      formErrors: [],
      form: {
        employee_name: "",
        date: "",
        form_date: "",
        punch_from: "",
        punch_in_time: "",
        punch_out_time: "",
        selected_designation: "",
        office_name: "",
        schedule_start_time: "",
        schedule_end_time: "",
      },
      pagination,
      hasCreatePermission: null,
      hasEditPermission: null,
      hasExportPermission: null,
      hasEMpCreatePermission: null,
    };
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    toggleNeedReview() {
      this.showNeedReview = !this.showNeedReview;
    },
    collectNoShowCards() {
      this.noShowCards = [];
      this.data.forEach((employee) => {
        if (employee.children) {
          employee.children.forEach((child) => {
            if (child.time_card === "No-Show") {
              this.noShowCards.push({
                parent: employee,
                ...child,
              });
            }
          });
        }
      });
    },
    onSearch() {
      let params = {
        params: {
          s_employee_id: this.searchForm.s_employee_id,
          designation_id: this.searchForm.designation_id,
          hide_empty_members: this.searchForm.hide_empty_members,
        },
      };
      this.searchForm.hide_empty_members
        ? (params.params.per_page = this.pagination.total)
        : (params.params.per_page = this.pagination.pageSize);
      this.fetchPayPeriodData(params);
    },
    clearForm() {
      this.searchForm = {
        s_employee_id: null,
        designation_id: null,
        hide_empty_members: false,
      };
      let params = {
        params: {
          s_employee_id: this.searchForm.s_employee_id,
          designation_id: this.searchForm.designation_id,
          hide_empty_members: this.searchForm.hide_empty_members,
          per_page: this.pagination.pageSize,
        },
      };
      this.fetchPayPeriodData(params);
    },
    openAddTimeCard(record = null) {
      this.formErrors = [];
      if (record) {
        this.selectedUserId = record.userId;
        this.selectedDesignationId = record.designationId;
      }
    },
    openModal(record) {
      this.form = {
        employee_name: "",
        date: "",
        form_date: "",
        punch_from: "",
        punch_in_time: "",
        punch_out_time: "",
        selected_designation: "",
        office_name: "",
        schedule_start_time: "",
        schedule_end_time: "",
      };
      this.formErrors = [];
      this.selectedtimesheet = JSON.parse(JSON.stringify(record));
      this.form.employee_name = this.selectedtimesheet.employee_name || "";

      this.form.selected_designation = this.selectedtimesheet
        .attendance_designationdetails
        ? this.selectedtimesheet.attendance_designationdetails.id
        : this.selectedtimesheet.role_id;

      this.form.office_name = this.selectedtimesheet.office_name || "";

      this.form.schedule_start_time = record.shift.shift.start_time;
      this.form.schedule_end_time = record.shift.shift.end_time;

      if (
        record?.list_breaks?.paid_breaks &&
        Array.isArray(record.list_breaks.paid_breaks)
      ) {
        this.selectedtimesheet.list_breaks.paid_breaks.forEach((b) => {
          b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
          b.punch_out_time_str = b.punch_out_employee_attendances_details_time;
        });
      }

      if (
        record?.list_breaks?.unpaid_breaks &&
        Array.isArray(record.list_breaks.unpaid_breaks)
      ) {
        this.selectedtimesheet.list_breaks.unpaid_breaks.forEach((b) => {
          b.punch_in_time_str = b.punch_in_employee_attendances_details_time;
          b.punch_out_time_str = b.punch_out_employee_attendances_details_time;
        });
      }

      this.form.date = record.date;
      this.form.form_date = record.form_date;
      this.form.punch_from = record.punch_in_from;
      if (record.attendance && record.attendance.firstpunch != "") {
        this.form.punch_in_time =
          record.attendance.firstpunch.converted_checkintime;
      }

      if (record.attendance && record.attendance.lastpunch != "") {
        this.form.punch_out_time =
          record.attendance.lastpunch.converted_checkouttime;
      }
    },
    extractTime(datetime) {
      if (!datetime) return null;
      return new Date(datetime).toTimeString().slice(0, 5); // HH:mm
    },
    handleExpand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.key);
      } else {
        this.expandedRowKeys = this.expandedRowKeys.filter(
          (key) => key !== record.key
        );
      }
      this.updateExpandAllState();
    },
    toggleExpandAll() {
      if (this.isAllExpanded) {
        this.expandedRowKeys = [];
      } else {
        this.expandedRowKeys = this.data.map((item) => item.key);
      }
      this.isAllExpanded = !this.isAllExpanded;
    },
    customRow(record) {
      return {
        onClick: () => {
          if (record.children) {
            this.toggleRow(record.key);
          }
        },
        style: {
          cursor: record.children ? "pointer" : "default",
        },
        class: record.isTotalRow ? "total-row" : "",
      };
    },
    handleRowClick(record) {
      if (record.children) {
        this.toggleRow(record.key);
      }
    },
    toggleRow(key) {
      const index = this.expandedRowKeys.indexOf(key);
      if (index >= 0) {
        this.expandedRowKeys.splice(index, 1);
      } else {
        this.expandedRowKeys.push(key);
      }
      this.updateExpandAllState();
    },
    updateExpandAllState() {
      this.isAllExpanded =
        this.data.length > 0 &&
        this.data.every((item) => this.expandedRowKeys.includes(item.key));
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    handleImageError(item) {
      item.avatar = null;
      item.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    reloadPayData() {
      let params = {
        params: {
          s_employee_id: this.searchForm.s_employee_id,
          designation_id: this.searchForm.designation_id,
          hide_empty_members: this.searchForm.hide_empty_members,
          per_page: this.pagination.pageSize,
          page: this.pagination.current,
        },
      };
      this.fetchPayPeriodData(params);
    },
    updatePerPage() {
      var params = {
        params: {
          per_page: this.pagination.pageSize,
          s_employee_id: this.searchForm.s_employee_id,
          designation_id: this.searchForm.designation_id,
          hide_empty_members: this.searchForm.hide_empty_members,
        },
      };
      this.fetchPayPeriodData(params);
    },
    handleTableChange(pagesize) {
      var params = {
        params: {
          per_page: pagesize.pageSize,
          page: pagesize.current,
          s_employee_id: this.searchForm.s_employee_id,
          designation_id: this.searchForm.designation_id,
          hide_empty_members: this.searchForm.hide_empty_members,
        },
      };
      this.fetchPayPeriodData(params);
    },
    fetchPayPeriodData(params) {
      this.loading = true;
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      let formattedStartDate = moment(this.startDate).format("YYYY-MM-DD");
      let formattedEndDate = moment(this.endDate).format("YYYY-MM-DD");

      if (new Date(formattedStartDate) > new Date(formattedEndDate)) {
        [this.startDate, this.endDate] = [this.endDate, this.startDate];
        formattedStartDate = moment(this.startDate).format("YYYY-MM-DD");
        formattedEndDate = moment(this.endDate).format("YYYY-MM-DD");
      }
      axios
        .get("/payperiodreview", {
          params: {
            start_date: formattedStartDate,
            end_date: formattedEndDate,
            ...params.params,
          },
        })
        .then((response) => {
          this.pagination.total = response.data.data.pagination.total;
          this.pagination.current = response.data.data.pagination.current_page;
          this.pagination.pageSize = response.data.data.pagination.per_page + 1;

          const newData = response.data.data.payperiod;
          this.data = newData.map((item, index) => ({
            ...item,
            key: item.key || `row-${index}`,
            children: item.children
              ? item.children.map((child, childIndex) => ({
                  ...child,
                  key: child.key || `row-${index}-child-${childIndex}`,
                }))
              : [],
          }));
          if (this.hasCreatePermission) {
            this.data = this.addTimeCardRow(this.data);
          }
          // Calculate totals row
          this.calculateTotals();
          loader.hide();
          this.loading = false;
          this.collectNoShowCards();
          this.expandedRowKeys = [];
        })
        .catch((error) => {
          this.loading = false;
          loader.hide();

          var response = error.response;

          if (
            error.response?.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
          console.error("Error fetching pay period data:", error);
        });
    },
    addTimeCardRow(data) {
      return data.map((user) => {
        user.children.push({
          key: `${user.key}-add-time-card`,
          isAddTimeCardRow: true,
          parentKey: user.key,
          userId: user.id,
          designationId: user.role_id,
        });
        return user;
      });
    },
    calculateTotals() {
      const totals = {
        key: "totals",
        isTotalRow: true,
        date: "Totals",
        role: "",
        wage_rate: "",
        time_card: "",
        issues: false,
        scheduled_hours: "0.00",
        actual_vs_scheduled: "0.00",
        total_paid_hours: "0.00",
        regular_hours: "0.00",
        unpaid_breaks: "0.00",
        ot_hours: "0.00",
        estimated_wages: "$0.00",
        cash_tips: "$0.00",
      };

      // Calculate sums from all employees
      this.data.forEach((employee) => {
        totals.scheduled_hours = (
          parseFloat(totals.scheduled_hours) +
          parseFloat(employee.scheduled_hours || 0)
        ).toFixed(2);
        totals.actual_vs_scheduled = (
          parseFloat(totals.actual_vs_scheduled) +
          parseFloat(employee.actual_vs_scheduled || 0)
        ).toFixed(2);
        totals.total_paid_hours = (
          parseFloat(totals.total_paid_hours) +
          parseFloat(employee.total_paid_hours || 0)
        ).toFixed(2);
        totals.regular_hours = (
          parseFloat(totals.regular_hours) +
          parseFloat(employee.regular_hours || 0)
        ).toFixed(2);
        totals.unpaid_breaks = (
          parseFloat(totals.unpaid_breaks) +
          parseFloat(employee.unpaid_breaks || 0)
        ).toFixed(2);
        totals.ot_hours = (
          parseFloat(totals.ot_hours) + parseFloat(employee.ot_hours || 0)
        ).toFixed(2);

        // Sum monetary values
        const empWages = parseFloat(
          employee.estimated_wages.replace(/[^0-9.-]+/g, "") || 0
        );
        const totalWages = parseFloat(
          totals.estimated_wages.replace(/[^0-9.-]+/g, "") || 0
        );
        totals.estimated_wages = `$${(totalWages + empWages).toFixed(2)}`;

        const empTips = parseFloat(
          employee.cash_tips.replace(/[^0-9.-]+/g, "") || 0
        );
        const totalTips = parseFloat(
          totals.cash_tips.replace(/[^0-9.-]+/g, "") || 0
        );
        totals.cash_tips = `$${(totalTips + empTips).toFixed(2)}`;
      });

      // Count roles and time cards
      const distinctRoles = new Set();
      let totalTimeCards = 0;

      this.data.forEach((employee) => {
        if (employee.children) {
          employee.children.forEach((day) => {
            if (day.role) distinctRoles.add(day.role);
            // if (day.time_card && day.time_card !== "No-Show") totalTimeCards++;
          });
        }
        totalTimeCards += parseInt(employee.time_card.split(" ")[0]);
      });

      totals.role = `${distinctRoles.size} Positions`;
      totals.time_card = `${totalTimeCards} Time Cards`;

      this.totalsRow = totals;
    },
    loadAllDesignations() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/designations/all")
        .then((response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            this.designation_list.push({
              id: response.data.data[i].id,
              text: response.data.data[i].name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadAllEmployees() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees")
        .then((response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    downloadPayPeriod(report) {
      const params = new URLSearchParams();
      const startDate = moment(this.startDate).format("YYYY-MM-DD");
      const endDate = moment(this.endDate).format("YYYY-MM-DD");
      if (this.startDate) {
        params.append("start_date", startDate);
      }
      if (this.endDate) {
        params.append("end_date", endDate);
      }

      if (this.searchForm) {
        Object.keys(this.searchForm).forEach((key) => {
          const value = this.searchForm[key];
          params.append(key, value);
        });
      }

      if (this.originalColumn?.length) {
        const columns_keys = this.originalColumn.map((column) => column.key);
        params.append("keys", columns_keys.join(","));
      }

      const token = window.localStorage.getItem("token");
      const url = `${
        process.env.VUE_APP_API_BASE_URL
      }${report}?${params.toString()}`;
      // window.location.href = url;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get(url, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);

          const contentDisposition = response.headers["content-disposition"];

          let fileName = `pay-period-review-${startDate}-to-${endDate}.xlsx`;
          if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href); // Clean up
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    downloadPayPeriodPDF(viewType = "default") {
      const startDate = moment(this.startDate).format("YYYY-MM-DD");
      const endDate = moment(this.endDate).format("YYYY-MM-DD");

      const params = {
        start_date: moment(this.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.endDate).format("YYYY-MM-DD"),
        export_as_pdf: 1,
        view_type: viewType,
      };

      Object.keys(params).forEach((key) => {
        if (!params[key]) delete params[key];
      });

      const token = window.localStorage.getItem("token");
      const queryString = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}export-pay-period?${queryString}`;

      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", "");
      // link.style.display = "none";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get(url, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);

          let fileName = `pay-period-review-${startDate}-to-${endDate}.pdf`;
          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  computed: {
    hasExpandableRows() {
      return this.data.some(
        (item) => item.children && item.children.length > 0
      );
    },
    dataWithKeys() {
      return this.data.map((item) => ({
        ...item,
        key: item.key || Math.random().toString(36).substr(2, 9),
      }));
    },
    dataWithKeysAndTotals() {
      return this.totalsRow
        ? [...this.dataWithKeys, this.totalsRow]
        : this.dataWithKeys;
    },
    originalColumn() {
      return this.columns.filter((column) => column.visibility);
    },
  },
  watch: {
    data() {
      if (this.showNeedReview) {
        this.collectNoShowCards();
      }
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "create" })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "employee", action: "create" })
      .then((response) => {
        this.hasEMpCreatePermission = null;
        this.$nextTick(() => {
          this.hasEMpCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "write" })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "export" })
      .then((response) => {
        this.hasExportPermission = null;
        this.$nextTick(() => {
          this.hasExportPermission = response === "true";
        });
      });

    let params = {
      params: {
        s_employee_id: this.searchForm.s_employee_id,
        designation_id: this.searchForm.designation_id,
        hide_empty_members: this.searchForm.hide_empty_members,
        per_page: this.pagination.pageSize,
      },
    };
    this.fetchPayPeriodData(params);
    this.loadAllEmployees();
    this.loadAllDesignations();
  },
};
</script>
<style scoped>
.card-body {
  padding: 20px;
}
.stripped {
  width: 100%;
  min-width: 1200px;
}
:deep(.ant-avatar .ant-avatar-string) {
  position: static;
}
:deep(.total-row) {
  font-weight: bold;
  background-color: #f0f0f0 !important;
}
:deep(.total-row .ant-table-cell) {
  font-weight: bold;
}
:deep(.total-row .text-danger) {
  color: inherit !important;
}
.btn-group {
  margin-right: 10px;
}
.dropdown-menu {
  min-width: 180px;
}
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -1px;
  display: none;
}

.dropdown-submenu:hover .dropdown-menu {
  display: block;
}

.dropdown-submenu .float-end {
  transition: transform 0.3s ease;
}
.filter-section {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  margin-bottom: 0;
}
.filter-section.show-filters {
  max-height: 200px;
  /* margin-bottom: 20px; */
}
.filter-row {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 5px;
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.no-show-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ff4d4f;
  color: white;
  font-size: 12px;
  font-weight: 500;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  padding: 0 6px;
  margin-left: 8px;
  line-height: 1;
}

.no-show-container {
  width: 100%;
  overflow-x: auto;
  padding: 10px 0;
  /* background: #fff9f9; */
  /* border-radius: 4px; */
  /* border: 1px solid #ffebee; */
}

.no-show-cards {
  display: flex;
  gap: 15px;
  padding: 0 15px;
  min-width: max-content;
}

.no-show-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  min-width: 220px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(253, 126, 20, 0.08);
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 7px;
}

.no-show-card:hover {
  border-color: rgba(253, 126, 20, 0.5);
  box-shadow: 0 2px 8px rgba(253, 126, 20, 0.1);
  transform: none;
}

.no-show-card:hover .card-overlay {
  opacity: 1;
}

.card-content {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.employee-info {
  display: flex;
  align-items: flex-start;
}

.employee-details {
  display: flex;
  flex-direction: column;
  /* margin-left: 12px; */
}

.employee-name {
  font-weight: 600;
  font-size: 14px;
  color: #212529;
  margin-bottom: 8px;
}

.attendance-date {
  font-size: 13px;
  color: #495057;
  margin-bottom: 4px;
}

.no-show-status {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background-color: #fff5f5;
  border-radius: 4px;
  margin-top: 4px;
}

.no-show-text {
  font-size: 13px;
  color: #ff4d4f;
  font-weight: 500;
}

/* Avatar sizing */
/* .ant-avatar {
  width: 40px;
  height: 40px;
  line-height: 40px;
} */
</style>
